// TODO: Удалить эксперимент в CD-190874.
export const CALLBACK_BUTTON_TEXT_EXPERIMENT = 'newbuiding_new_callback_button_desktop';

// TODO: Удалить эксперимент в CD-199910.
export const LEAD_FACTORY_PAGE_EXPERIMENT = 'newbuilding_new_kpn_cardjk_desktop';

export const NEWBUILDING_ADFOX_SITE_JK_DESKTOP = 'newbuilding_adfox_site_jk_desktop';

export const NEWBUILDING_AA_TEST_50 = 'newbuiliding_test_for_expf_desktop_50_50';
export const NEWBUILDING_AA_TEST_30 = 'newbuiliding_test_for_expf_desktop_70_30';
